export default {
  importPlansFor: 'Importar planes para el modelo:',
  import: 'Importar',
  json: 'JSON',
  createdPlans: 'Planes creados:',
  errors: 'Errores:',
  invalidJson: 'JSON inválido',
  noPlansToImport: 'No hay planes disponibles para importar',
  missingPlanName: 'Falta el nombre del plan',
  channelMismatch: 'Sus canales de medios no coinciden exactamente con el modelo. Faltan en el plan: {missing}. No están en el modelo: {extra}. No se importó nada.',
  touchpointMismatch: 'Referencia medios que no existen en el modelo: {items}. No se importó nada.'
}
